export default {
  hero_label: 'SERVICE',
  hero_title_en: 'AIX Training',
  hero_title_ja: 'AIX Training',
  hero_desc: 'From raising AI literacy to cultivating specialized AI talent, we provide fully customized programs tailored to your organization and industry.',
  overview_label: 'OVERVIEW',
  overview_title: 'Service Overview',
  overview_desc: 'AIX Training is a talent development service that elevates the AI utilization level of the entire organization, from raising AI literacy to cultivating internal AI leaders.\n\nWe emphasize practical training directly linked to actual business operations, not just knowledge provision. Through fully customized programs tailored to your industry, organization size, and proficiency level, we cultivate AI talent who can truly perform on the frontlines.',
  programs_label: 'PROGRAMS',
  programs_title: 'Program Types',
  program_1_label: 'For All Employees',
  program_1_desc: 'AI Literacy Foundation Training',
  program_1_detail: 'Introductory training to learn AI basics, generative AI tool fundamentals, and the first steps toward operational utilization.',
  program_2_label: 'For Managers',
  program_2_desc: 'AI Management & Leader Training',
  program_2_detail: 'Specialized training focused on AI investment decision-making, team AI utilization promotion, and change management.',
  program_3_label: 'For Engineers',
  program_3_desc: 'AI Development & Implementation Training',
  program_3_detail: 'Hands-on training directly linked to implementation, such as LLM API utilization, RAG construction, and AI agent development.',
  program_4_label: 'For Business Professionals',
  program_4_desc: 'Generative AI Business Application Training',
  program_4_detail: 'Practical training to hone generative AI utilization skills in daily operations such as proposals, reports, and analysis reports.',
  services_label: 'SERVICES',
  services_title: 'Main Service Areas',
  service_1_title: 'AI Literacy Training',
  service_1_desc: 'Providing AI literacy training for all employees, from AI basics to practical business applications. We build a foundation for correctly understanding AI and leveraging it in daily operations.',
  service_2_title: 'AI Utilization Practical Training',
  service_2_desc: 'Conducting role-based practical training tailored to job functions and business content. Acquire AI skills such as generative AI and data analysis tools that can be immediately applied in practice.',
  service_3_title: 'AI Talent Development Program',
  service_3_desc: 'A systematic program for cultivating internal AI promotion leaders and AI utilization specialists. We continuously produce talent capable of driving AI adoption within the organization.',
  service_4_title: 'Custom Training Design',
  service_4_desc: 'Designing fully customized training programs tailored to industry, organization size, and AI utilization level. We focus on acquiring knowledge and skills that can truly be used on the frontlines.',
  challenges_label: 'CHALLENGES',
  challenges_title: 'We Solve These Challenges',
  challenge_1: 'Employees have low AI literacy, and AI adoption is not progressing',
  challenge_2: 'AI utilization know-how is concentrated among a few staff members',
  challenge_3: 'Training was conducted but has not led to practical application on the frontlines',
  challenge_4: 'There is a large gap in AI utilization levels across departments and positions',
  challenge_5: 'There are no internal candidates being cultivated to drive AI adoption',
  challenge_6: 'Cannot find AI training specialized for our industry and operations',
  reasons_label: 'WHY AIX JAPAN',
  reasons_title: 'Why Companies Choose AIX JAPAN',
  reason_1_title: 'Fully Customized Design',
  reason_1_desc: 'Through thorough consultation, we design completely custom programs tailored to industry, position, and current AI level. We provide practical skills unattainable through off-the-shelf training.',
  reason_2_title: 'Rich Industry-Specific Knowledge',
  reason_2_desc: 'Based on training track records across diverse industries such as manufacturing, finance, retail, healthcare, and IT, we provide instruction with concrete AI utilization cases aligned with each industry\'s language and challenges.',
  reason_3_title: 'Practice-Focused Program Design',
  reason_3_desc: 'Rather than knowledge cramming, we combine hands-on workshops and business simulations so participants acquire skills they can use the very next day.',
  reason_4_title: 'Long-Term Support Until Adoption',
  reason_4_desc: 'With continuous support including post-training follow-up, workplace practice support, and proficiency testing, we reliably connect learning to results.',
  flow_label: 'FLOW',
  flow_title: 'Training Implementation Flow',
  flow_intro: 'From assessment to post-training adoption, we clarify the work and deliverables of each step. Durations vary by cohort size and format and are indicative only.',
  flow_steps: [
    {
      no: '01',
      icon: 'ri-survey-line',
      title: 'Current State Assessment',
      note: 'Free initial consult',
      duration: 'approx. 1-2 weeks',
      activities: [
        'AI literacy survey of employees (questionnaires, etc.)',
        'Interviews on business challenges and training goals, mapping of participants',
      ],
      deliverables: ['Assessment summary', 'Prioritized development themes'],
      clientAsks: ['Responses to the participant survey', 'Alignment on training goals'],
    },
    {
      no: '02',
      icon: 'ri-book-open-line',
      title: 'Program Design',
      duration: 'approx. 2-3 weeks',
      activities: [
        'Curriculum design tailored to industry, roles, and proficiency',
        'Customization of materials and exercises to your work; format design (on-site/online)',
      ],
      deliverables: ['Training curriculum', 'Full set of materials'],
      clientAsks: ['Work materials to base exercises on', 'Schedule coordination'],
    },
    {
      no: '03',
      icon: 'ri-presentation-line',
      title: 'Training Delivery',
      duration: 'Half-day sessions x several (per design)',
      activities: [
        'Delivery combining lectures, hands-on sessions, and workshops',
        'Exercises based on your actual work, with comprehension checks',
      ],
      deliverables: ['Delivery report', 'Participant comprehension summary'],
      clientAsks: ['Securing participants\' time', 'Real work materials for exercises'],
    },
    {
      no: '04',
      icon: 'ri-line-chart-line',
      title: 'Measurement & Follow-up',
      duration: '1-3 months after training',
      activities: [
        'Measurement of proficiency and workplace change, follow-up training',
        'Ongoing support for in-house AI champions',
      ],
      deliverables: ['Effectiveness report', 'Proposal for the next development plan'],
      clientAsks: ['Sharing of on-the-job practice status', 'Follow-up scheduling'],
    },
  ],
};